import { defaultSentimentFilter } from './constants'

export const getNotesParams = ({ filterParams, page, pageSize, search, selectedSentimentFilter }) => {
  const params = { ...filterParams, page, page_size: pageSize }

  if (search) params.q = search
  if (selectedSentimentFilter !== defaultSentimentFilter) params.sentiment = selectedSentimentFilter

  return params
}
